/**
 * 模块路由配置
 */
import { subRoutes as supConfigRoutes } from './supConfig/SupConfigModule';
import { subRoutes as spdManageRoutes } from './spdManage/SpdManageModule';
import { subRoutes as supProviderRoutes } from './supProvider/SupProviderModule';
import { subRoutes as supLicenseRoutes } from './supLicense/SupLicenseModule';
import { subRoutes as supProductRoutes } from './supProduct/SupProductModule';
import { subRoutes as supOrderRoutes } from './supOrder/SupOrderModule';
import { subRoutes as supDeliveryRoutes } from './supDelivery/SupDeliveryModule';
import { subRoutes as supInventoryRoutes } from './supInventory/SupInventoryModule';
import { subRoutes as supOperationRoutes } from './supOperation/SupOperationModule';
import { subRoutes as supCostRoutes } from './supCost/SupCostModule';
import { subRoutes as spdBillRoutes } from './spdBill/SpdBillModule';
import { subRoutes as supCreditRoutes } from './supCredit/SupCreditModule';
import { subRoutes as smsRoutes } from './sms/SmsModule';
// ---------------------- 总务 ---------------------------------
import { subRoutes as offProductRoutes } from './offProduct/OffProductModule';
import { subRoutes as offDeliveryRoutes } from './offDelivery/OffDeliveryModule';
import { subRoutes as offCostRoutes } from './offCost/OffCostModule';
import { subRoutes as offOrderRoutes } from './offOrder/OffOrderModule';
// ---------------------- 定制化 ---------------------------------
import { subRoutes as jyzyyRoutes } from './jyzyy/JyzyyModule';
import { subRoutes as ncrmRoutes } from './custom/ncrm/NcrmModule';
import { subRoutes as zbzqRoutes } from './custom/zbzq/ZbzqModule';
import { subRoutes as akzxRoutes } from './akzx/AkzxModule';
import { subRoutes as esmdRoutes } from './custom/esmd/esmdInventoryQuery/EsmdModule';
import { subRoutes as lndyRoutes } from './custom/lndy/LndyModule';
import { subRoutes as nxrmRoutes } from './custom/nxrm/NxrmModule';
import { subRoutes as ycrmRoutes } from './custom/ycrm/YcrmModule';
import { subRoutes as yl2yRoutes } from './custom/yl2y/Yl2yModule';
import { subRoutes as hbzlRoutes } from './custom/hbzl/HbzlModule';
import { subRoutes as hkgtRoutes } from './custom/hkgt/HkgtModule';
import { subRoutes as hkrmRoutes } from './custom/hkrm/HkrmModule';
import { subRoutes as lfzxRoutes } from './custom/lfzx/LfzxModule';
import { subRoutes as zzrmRoutes } from './custom/zzrm/ZzrmModule';
import { subRoutes as xa9yRoutes } from './custom/xa9y/Xa9yModule';
import { subRoutes as ylrmRoutes } from './custom/ylrm/YlrmModule';
import { subRoutes as syzxRoutes } from './custom/syzx/SyzxModule';
import { subRoutes as xxbsRoutes } from './custom/xxbs/XxbsModule';
import { subRoutes as fdrmRoutes } from './custom/fdrm/FdrmModule';
import { subRoutes as mgrmRoutes } from './custom/mgrm/MgrmModule';
import { subRoutes as mgzyyRoutes } from './custom/mgzyy/MgzyyModule';
import { subRoutes as lyrmRoutes } from './custom/lyrm/LyrmModule';
import { subRoutes as shjsRoutes } from './custom/shjs/ShjsModule';
import { subRoutes as xadyRoutes } from './custom/xady/XadyModule';
import { subRoutes as sxzxRoutes } from './custom/sxzx/SxzxModule';
import { subRoutes as hzjlsRoutes } from './custom/hzjls/HzjlsModule';
import { subRoutes as bjxkRoutes } from './custom/bjxk/BjxkModule';
import { subRoutes as bjhrRoutes } from './custom/bjhr/BjhrModule';
import { subRoutes as nb6yRoutes } from './custom/nb6y/Nb6yModule';

// ---------------------- 药品 ---------------------------------
import { subRoutes as medDeliveryRoutes } from './medDelivery/MedDeliveryModule';
import { subRoutes as medManageRoutes } from './medManage/MedManageModule';
import { subRoutes as medOrderRoutes } from './medOrder/MedOrderModule';
import { subRoutes as medProductRoutes } from './medProduct/MedProductModule';
import { subRoutes as medMedCostRoutes } from './medCost/MedCostModule';
import { subRoutes as drugOrderRoutes } from './drugOrder/DrugOrderModule';
import { subRoutes as drugProductRoutes } from './drugProduct/DrugProductModule';
import { subRoutes as drugCostRoutes } from './drugCost/DrugCostModule';
import { subRoutes as drugLicenseRoutes } from './drugLicense/DrugLicenseModule';

// ---------------------4.0平台迁移-----------------------------------------
import { subRoutes as sup40Routes } from './custom/sup40/sup40Module';
// ---------------------sass50-----------------------------------------
import { subRoutes as saas50 } from './saas50/Saas50Moudle';


export const routes = [
  {
    path: '/supConfig',
    subRoutes: supConfigRoutes
  },
  {
    path: '/spdManage',
    subRoutes: spdManageRoutes
  },
  {
    path: '/supProvider',
    subRoutes: supProviderRoutes
  },
  {
    path: '/supLicense',
    subRoutes: supLicenseRoutes
  },
  {
    path: '/supProduct',
    subRoutes: supProductRoutes
  },
  {
    path: '/medProduct',
    subRoutes: medProductRoutes
  },
  {
    path: '/medCost',
    subRoutes: medMedCostRoutes
  },
  {
    path: '/supOrder',
    subRoutes: supOrderRoutes
  },
  {
    path: '/medOrder',
    subRoutes: medOrderRoutes
  },
  {
    path: '/supDelivery',
    subRoutes: supDeliveryRoutes
  },
  {
    path: '/supInventory',
    subRoutes: supInventoryRoutes
  },
  {
    path: '/medDelivery',
    subRoutes: medDeliveryRoutes
  },
  {
    path: '/medManage',
    subRoutes: medManageRoutes
  },
  {
    path: '/supOperation',
    subRoutes: supOperationRoutes
  },
  {
    path: '/supCost',
    subRoutes: supCostRoutes
  },
  {
    path: '/spdBill',
    subRoutes: spdBillRoutes
  },
  {
    path: '/supCredit',
    subRoutes: supCreditRoutes
  },
  {
    path: '/sms',
    subRoutes: smsRoutes
  },
  {
    path: '/saas50',
    subRoutes: saas50
  },
  {
    path: '/offProduct',
    subRoutes: offProductRoutes
  },
  {
    path: '/offDelivery',
    subRoutes: offDeliveryRoutes
  },
  {
    path: '/offCost',
    subRoutes: offCostRoutes
  },
  {
    path: '/offOrder',
    subRoutes: offOrderRoutes
  },
  {
    path: '/jyzyy',
    subRoutes: jyzyyRoutes
  },
  {
    path: '/ncrm',
    subRoutes: ncrmRoutes
  },
  {
    path: '/zbzq',
    subRoutes: zbzqRoutes
  },
  {
    path: '/akzx',
    subRoutes: akzxRoutes
  },
  {
    path: '/esmd',
    subRoutes: esmdRoutes
  },
  {
    path: '/drugOrder',
    subRoutes: drugOrderRoutes
  },
  {
    path: '/drugProduct',
    subRoutes: drugProductRoutes
  },
  {
    path: '/drugCost',
    subRoutes: drugCostRoutes
  },
  {
    path: '/drugLicense',
    subRoutes: drugLicenseRoutes
  },
  {
    path: '/lndy',
    subRoutes: lndyRoutes
  },
  {
    path: '/nxrm',
    subRoutes: nxrmRoutes
  },
  {
    path: '/ycrm',
    subRoutes: ycrmRoutes
  },
  {
    path: '/yl2y',
    subRoutes: yl2yRoutes
  },
  {
    path: '/hbzl',
    subRoutes: hbzlRoutes
  },
  {
    path: '/hkgt',
    subRoutes: hkgtRoutes
  },
  {
    path: '/hkrm',
    subRoutes: hkrmRoutes
  },
  {
    path: '/lfzx',
    subRoutes: lfzxRoutes
  },
  {
    path: '/zzrm',
    subRoutes: zzrmRoutes
  },
  {
    path: '/xa9y',
    subRoutes: xa9yRoutes
  },
  {
    path: '/ylrm',
    subRoutes: ylrmRoutes
  },
  {
    path: '/syzx',
    subRoutes: syzxRoutes
  },
  {
    path: '/fdrm',
    subRoutes: fdrmRoutes
  },
  {
    path: '/40Sup',
    subRoutes: sup40Routes
  },
  {
    path: '/xxbs',
    subRoutes: xxbsRoutes
  },
  {
    path: '/mgrm',
    subRoutes: mgrmRoutes
  },
  {
    path: '/mgzyy',
    subRoutes: mgzyyRoutes
  },
  {
    path: '/lyrm',
    subRoutes: lyrmRoutes
  },
  {
    path: '/shjs',
    subRoutes: shjsRoutes
  },
  {
    path: '/xady',
    subRoutes: xadyRoutes
  },
  {
    path: '/sxzx',
    subRoutes: sxzxRoutes
  },
  {
    path: '/hzjls',
    subRoutes: hzjlsRoutes
  },
  {
    path: '/bjxk',
    subRoutes: bjxkRoutes
  },
  {
    path: '/bjhr',
    subRoutes: bjhrRoutes
  },
  {
    path: '/nb6y',
    subRoutes: nb6yRoutes
  }
];
